import React from 'react';
import ReactPlayer from 'react-player';
import btn from 'legacy/src/utility/btn';
import RichText from 'legacy-src/utility/RichText';
import cn from 'classnames';

import './wistia.scss';

class Player extends React.Component {
  static displayName = 'Wistia';
  constructor(props) {
    super(props);

    this.state = {};

    this._rawSetWidth = this._rawSetWidth.bind(this);
    this._toggleTranscript = this._toggleTranscript.bind(this);
    this.getDuration = this.getDuration.bind(this);
    this.trackProgress = this.trackProgress.bind(this);
  }

  getInitialState() {
    return {
      height: '',
      limitedWidth: true,
      transcriptOpen: false,
    };
  }

  componentDidMount() {
    this._setWidth = _.debounce(this._rawSetWidth, 125, { leading: true }).bind(
      this,
    );
    window.addEventListener('resize', this._setWidth);
    this._setWidth();
  }

  componentDidUpdate() {
    this._setWidth();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._setWidth);
  }

  _rawSetWidth() {
    try {
      var wistiaWrapper = React.findDOMNode(this);
      var wistiaVideo = this.refs.wistiaContent.getDOMNode();
    } catch (e) {
      return;
    }
    const componentWidth = wistiaWrapper.offsetWidth;
    const width = wistiaVideo.offsetWidth;
    if (!_.isEqual(width, this.state.width)) {
      const height = width / 1.77; // 16:9 aspect ratio
      const limitedWidth = componentWidth < 710; // our "small" breakpointf
      this.setState({ height, width, limitedWidth });
    }
  }

  _toggleTranscript() {
    if (this.state.transcriptOpen) {
      this.setState({ transcriptOpen: false, closing: true });
      setTimeout(() => this.setState({ closing: false }), 250);
    } else {
      this.setState({ transcriptOpen: true });
    }
  }

  render() {
    const {
      item: { content },
    } = this.props;
    const { transcriptOpen, height, limitedWidth } = this.state;

    const url = `https://academicmerit.wistia.com/medias/${content.key}`;

    return (
      <div
        className={cn(
          'wistia__wrapper',
          { 'wistia__wrapper--transcript-open': transcriptOpen },
          { 'wistia__wrapper--small': limitedWidth },
        )}
        data-am-type="media/wistia"
      >
        <div className="wistia__content" ref="wistiaContent">
          <ReactPlayer
            className="wistia__player_wrapper"
            url={url}
            onProgress={this.trackProgress}
            onDuration={this.getDuration}
            height={height}
            width="100%"
          />
          {content.transcript ? (
            <button
              className={cn(
                'wistia__transcript-toggle',
                btn({ color: 'gray' }),
              )}
              onClick={this._toggleTranscript}
            >
              {transcriptOpen ? 'Close transcript' : 'Show transcript'}
            </button>
          ) : null}
        </div>
        {transcriptOpen ? (
          <div
            className={cn('wistia__transcript', {
              'wistia__transcript--open': transcriptOpen,
            })}
          >
            <RichText content={content.transcript} />
          </div>
        ) : null}
      </div>
    );
  }

  getDuration(videoLength) {
    this.setState({ videoLength });
  }

  trackProgress({ location }) {
    const { videoLength } = this.state;
    this.props.submission.setState({
      currentTime: location,
      totalTime: videoLength,
      totalComplete:
        (videoLength - location > 2 ? location : videoLength) / videoLength ||
        0,
    });
  }
}

function status(item, state = {}) {
  return {
    viewed: state.viewed ? 1 : 0,
    complete: state.totalComplete || 0,
  };
}

export default { Player, status };
